module.exports = __webpack_public_path__ + "src/assets/img/door_right.1cf533cc.svg";